module.exports = __webpack_public_path__ + "img/jd.655f7148.png";